// @flow
import { selectCurrentId } from '@gandi/redux-sharing';

import { useAppSelector } from 'src/hooks/useAppSelector';
import {
  mailboxOffersResource,
  selectSellableMailboxOffers,
  selectCanSellStandardMailbox,
  selectMailboxOffers,
} from 'src/modules/mailbox/offers';

import { useListResource } from './resource';
import type { ResourceStatuses } from './resource';

export function useMailboxOffers(): {
  ...ResourceStatuses,
  sellable: ReturnType<typeof selectSellableMailboxOffers>,
  offers: ReturnType<typeof selectMailboxOffers>,
  canSellStandardMailbox: ReturnType<typeof selectCanSellStandardMailbox>,
} {
  const sharingId = useAppSelector(selectCurrentId);

  const { url, label, params, actionExtraParams } =
    mailboxOffersResource.options.getListConfig(sharingId);
  const resourceStatuses = useListResource(mailboxOffersResource, url, label, {
    params,
    actionExtraParams,
  });

  const canSellStandardMailbox = useAppSelector(selectCanSellStandardMailbox);

  const sellable = useAppSelector(state =>
    selectSellableMailboxOffers(state, sharingId),
  );

  const offers = useAppSelector(state => selectMailboxOffers(state, sharingId));

  return {
    canSellStandardMailbox,
    sellable,
    offers,
    ...resourceStatuses,
  };
}
